import React from 'react';

/**
 * Chip de severidade da assimetria craniana: o valor e a etiqueta colorida.
 * Usado pela tabela do histórico, pelos cards do celular e pelo registro
 * fotográfico, para que exista uma única aparência de chip no módulo.
 *
 * @param {string} value valor formatado (ex.: "82.30%")
 * @param {string} label severidade (ex.: "Normal")
 * @param {string} color cor de fundo da etiqueta
 * @param {string} textColor cor do texto da etiqueta
 * @param {boolean} compact versão em linha (cards do celular e fotos)
 * @param {string} prefix rótulo opcional antes do valor (ex.: "CVAI")
 */
const CranialSeverityChip = ({ value, label, color, textColor, compact = false, prefix }) => {
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

    if (compact) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {prefix && (
                    <span style={{ fontSize: '12px', color: 'var(--color-text-light, #718096)' }}>{prefix}</span>
                )}
                <span style={{ fontWeight: 600, fontSize: '15px' }}>{`${value}`}</span>
                <div style={{
                    borderRadius: '20px',
                    padding: '3px 10px',
                    backgroundColor: color,
                    minWidth: '60px',
                    textAlign: 'center'
                }}>
                    <span style={{ fontSize: '12px', color: textColor, whiteSpace: 'nowrap', fontWeight: 600 }}>
                        {`${label}`}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: isMobile ? '2px' : '4px'
        }}>
            <span style={{ fontWeight: 500, fontSize: isMobile ? '11px' : 'inherit' }}>{`${value}`}</span>
            <div style={{
                borderRadius: '20px',
                padding: isMobile ? '2px 6px' : '3px 10px',
                backgroundColor: color,
                minWidth: isMobile ? '60px' : '80px',
                textAlign: 'center'
            }}>
                <span style={{ fontSize: isMobile ? '10px' : '12px', color: textColor, whiteSpace: 'nowrap', fontWeight: 500 }}>
                    {`${label}`}
                </span>
            </div>
        </div>
    );
};

export default CranialSeverityChip;
